export default __webpack_public_path__ + "static/media/add-single-material.cf136ded.svg";